// src/components/motion/GoldSpinner.tsx
// 素のCircularProgressに代わるブランドの金アークスピナー。
import React from 'react';
import { Box } from '@mui/material';

interface Props {
    size?: number;
    thickness?: number;
    label?: string;
}

const GoldSpinner: React.FC<Props> = ({ size = 40, thickness = 3, label }) => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1.25,
            }}
            role="progressbar"
            aria-label={label || '読み込み中'}
        >
            <Box
                component="svg"
                viewBox="0 0 50 50"
                sx={{
                    width: size,
                    height: size,
                    '@media (prefers-reduced-motion: no-preference)': {
                        animation: 'gold-spin 0.9s linear infinite',
                    },
                    '@keyframes gold-spin': {
                        from: { transform: 'rotate(0deg)' },
                        to: { transform: 'rotate(360deg)' },
                    },
                }}
            >
                <defs>
                    <linearGradient id="goldArc" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#F0CE7E" />
                        <stop offset="100%" stopColor="#C9A227" />
                    </linearGradient>
                </defs>
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="rgba(228,185,91,0.14)"
                    strokeWidth={thickness}
                />
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="url(#goldArc)"
                    strokeWidth={thickness}
                    strokeLinecap="round"
                    strokeDasharray="90 150"
                />
            </Box>
            {label && (
                <Box sx={{ color: 'text.secondary', fontSize: 13 }}>{label}</Box>
            )}
        </Box>
    );
};

export default GoldSpinner;
